import { render, staticRenderFns } from "./language-picker.vue?vue&type=template&id=4d1fa0e0&"
import script from "./language-picker.vue?vue&type=script&lang=ts&"
export * from "./language-picker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports